import React, { useMemo, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";

import Receipt from "./pages/receipt";
import Sidebar from "./Sidebar";
import CheklarTarixi from "./pages/CheklarTarixi";
import Dashboard from "./pages/Dashboard";
import Sotuvchilar from "./pages/Sotuvchilar";
import Sotuv from "./pages/Sotuv";
import BozorTarix from "./pages/BozorTarix";
import Buyurtmalar from "./pages/Buyurtmalar";
import Ombor from "./pages/Ombor";
import Kassa from "./pages/Kassa";
import Maxsulotqosh from "./pages/Maxsulotqosh";
import MaxsulotTarix from "./pages/MaxsulotTarix";
import Vozvrat from "./pages/Vozvrat";
import Hisobkitob from "./pages/Hisobkitob";
import Sozlamalar from "./pages/Sozlamalar";
import Login from "./pages/Login";
import Foyda from "./pages/foyda";
import Accauntlar from "./pages/Accauntlar";
import StoreLayout from "./shop/components/StoreLayout";
import StoreHomePage from "./shop/pages/StoreHomePage";
import CatalogPage from "./shop/pages/CatalogPage";
import ProductDetailPage from "./shop/pages/ProductDetailPage";
import CartPage from "./shop/pages/CartPage";
import { CartProvider } from "./shop/cart";

import { getToken, getUser as getStoredUser } from "./auth";
import {
  ADMIN_BASE_PATH,
  ADMIN_LOGIN_PATH,
  STORE_CART_PATH,
  STORE_CATALOG_PATH,
  STORE_HOME_PATH,
  adminPath,
  getAdminFallbackPath,
  legacyStorePath,
  storeProductPath,
} from "./routes";
import { SkladProvider } from "./SkladContext";
import SkladBar from "./SkladBar";
import "./App.css";


const getUserLS = () => getStoredUser() || null;


function privateFallback(user) {
  return getAdminFallbackPath(user);
}


function RequireAuth() {
  const location = useLocation();
  const token = getToken();

  if (!token) {
    return <Navigate replace state={{ from: location }} to={ADMIN_LOGIN_PATH} />;
  }

  return <Outlet />;
}


function StoreRoot() {
  return (
    <CartProvider>
      <StoreLayout />
    </CartProvider>
  );
}


function RequirePerm({ perm, children }) {
  const location = useLocation();
  const token = getToken();

  if (!token) {
    return <Navigate replace state={{ from: location }} to={ADMIN_LOGIN_PATH} />;
  }

  const user = getUserLS();
  const role = (user?.role || "").toLowerCase();
  const perms = user?.perms || {};
  const isAdmin = role === "admin";
  const isCashier = role === "cashier" || role === "seller";
  const anyPermOn = Object.values(perms).some((value) => !!value);
  const fallback = privateFallback(user);

  if (!perm) {
    return children;
  }

  if (isAdmin) {
    if (!anyPermOn) {
      return children;
    }
    return perms[perm] ? <Navigate replace to={fallback} /> : children;
  }

  if (isCashier) {
    if (!anyPermOn) {
      return <Navigate replace to={fallback} />;
    }
    return perms[perm] ? children : <Navigate replace to={fallback} />;
  }

  return <Navigate replace to={fallback} />;
}


function HomeRoute() {
  const user = getUserLS();
  const role = (user?.role || "").toLowerCase();

  if (role === "seller" || role === "cashier") {
    return <Navigate replace to={adminPath("Sotuv")} />;
  }

  return <Dashboard />;
}


function PreserveSearchRedirect({ to }) {
  const location = useLocation();
  return <Navigate replace to={`${to}${location.search || ""}`} />;
}


function LegacyStoreProductRedirect() {
  const { slug } = useParams();
  const location = useLocation();
  return <Navigate replace to={`${storeProductPath(slug)}${location.search || ""}`} />;
}


function LegacyAdminReceiptRedirect() {
  const { id } = useParams();
  const location = useLocation();
  return <Navigate replace to={`${adminPath(`chek/${id}`)}${location.search || ""}`} />;
}


function InternalLayout({ role, user }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((current) => !current);

  const [expanded, setExpanded] = useState(() => {
    try { return localStorage.getItem("yt_sidebar_expanded") === "1"; } catch (_) { return false; }
  });
  const toggleExpanded = () =>
    setExpanded((c) => {
      const next = !c;
      try { localStorage.setItem("yt_sidebar_expanded", next ? "1" : "0"); } catch (_) {}
      return next;
    });

  return (
    <div className={`app${expanded ? " sidebar-expanded" : ""}`}>
      <button className="toggle-btn" onClick={toggleSidebar}>
        Menu
      </button>

      <Sidebar
        isOpen={sidebarOpen}
        onClose={toggleSidebar}
        role={role}
        user={user}
        expanded={expanded}
        onToggleExpanded={toggleExpanded}
      />

      <div className="content">
        <div className="fr-shell">
          <main className="fr-main">
            <SkladBar />
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}


export default function App() {
  const token = getToken();
  const user = useMemo(getUserLS, [token]);
  const role = (user?.role || "").toLowerCase();

  return (
    <Router>
      <SkladProvider>
      <Routes>
        <Route element={<StoreRoot />}>
          <Route element={<StoreHomePage />} path={STORE_HOME_PATH} />
          <Route element={<CatalogPage />} path={STORE_CATALOG_PATH} />
          <Route element={<ProductDetailPage />} path={storeProductPath(":slug")} />
          <Route element={<CartPage />} path={STORE_CART_PATH} />
        </Route>

        <Route path={ADMIN_BASE_PATH}>
          <Route element={<Login />} path="login" />

          <Route element={<RequireAuth />}>
            <Route element={<InternalLayout role={role} user={user} />}>
              <Route
                element={
                  <RequirePerm perm="Dashboard">
                    <HomeRoute />
                  </RequirePerm>
                }
                index
              />
              <Route
                element={
                  <RequirePerm perm="Dashboard">
                    <HomeRoute />
                  </RequirePerm>
                }
                path="dashboard"
              />

              <Route
                element={
                  <RequirePerm perm="Savdo">
                    <Sotuv />
                  </RequirePerm>
                }
                path="Sotuv"
              />
              <Route
                element={
                  <RequirePerm perm="Savdo">
                    <CheklarTarixi />
                  </RequirePerm>
                }
                path="CheklarTarixi"
              />
              <Route
                element={
                  <RequirePerm perm="Buyurtmalar">
                    <Buyurtmalar />
                  </RequirePerm>
                }
                path="Buyurtmalar"
              />
              <Route
                element={
                  <RequirePerm perm="Buyurtmalar">
                    <BozorTarix />
                  </RequirePerm>
                }
                path="BozorTarix"
              />
              <Route
                element={
                  <RequirePerm perm="Savdo">
                    <Receipt />
                  </RequirePerm>
                }
                path="chek/:id"
              />

              <Route
                element={
                  <RequirePerm perm="Ombor">
                    <Ombor />
                  </RequirePerm>
                }
                path="Ombor"
              />
              <Route
                element={
                  <RequirePerm perm="Kassa">
                    <Kassa />
                  </RequirePerm>
                }
                path="Kassa"
              />
              <Route
                element={
                  <RequirePerm perm="Hisobkitob">
                    <Hisobkitob />
                  </RequirePerm>
                }
                path="Hisobkitob"
              />
              <Route
                element={
                  <RequirePerm perm="Accauntlar">
                    <Accauntlar />
                  </RequirePerm>
                }
                path="accauntlar"
              />
              <Route
                element={
                  <RequirePerm perm="Mijozlar">
                    <Sotuvchilar />
                  </RequirePerm>
                }
                path="Sotuvchilar"
              />
              <Route
                element={
                  <RequirePerm perm="Maxsulotqosh">
                    <Maxsulotqosh />
                  </RequirePerm>
                }
                path="Maxsulotqosh"
              />
              <Route
                element={
                  <RequirePerm perm="MaxsulotTarix">
                    <MaxsulotTarix />
                  </RequirePerm>
                }
                path="MaxsulotTarix"
              />
              <Route
                element={
                  <RequirePerm perm="Vozvrat">
                    <Vozvrat />
                  </RequirePerm>
                }
                path="Vozvrat"
              />
              <Route
                element={
                  <RequirePerm perm="Sozlamalar">
                    <Sozlamalar />
                  </RequirePerm>
                }
                path="Sozlamalar"
              />
              <Route
                element={
                  <RequirePerm perm="Foyda">
                    <Foyda />
                  </RequirePerm>
                }
                path="foyda"
              />
            </Route>
          </Route>
        </Route>

        <Route element={<PreserveSearchRedirect to={STORE_HOME_PATH} />} path={legacyStorePath()} />
        <Route
          element={<PreserveSearchRedirect to={STORE_CATALOG_PATH} />}
          path={legacyStorePath("catalog")}
        />
        <Route element={<LegacyStoreProductRedirect />} path={legacyStorePath("products/:slug")} />
        <Route
          element={<PreserveSearchRedirect to={STORE_CART_PATH} />}
          path={legacyStorePath("savat")}
        />

        <Route element={<PreserveSearchRedirect to={ADMIN_LOGIN_PATH} />} path="/login" />
        <Route element={<PreserveSearchRedirect to={adminPath("dashboard")} />} path="/dashboard" />
        <Route element={<PreserveSearchRedirect to={adminPath("Sotuv")} />} path="/Sotuv" />
        <Route
          element={<PreserveSearchRedirect to={adminPath("CheklarTarixi")} />}
          path="/CheklarTarixi"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("Buyurtmalar")} />}
          path="/Buyurtmalar"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("BozorTarix")} />}
          path="/BozorTarix"
        />
        <Route element={<LegacyAdminReceiptRedirect />} path="/chek/:id" />
        <Route element={<PreserveSearchRedirect to={adminPath("Ombor")} />} path="/Ombor" />
        <Route element={<PreserveSearchRedirect to={adminPath("Kassa")} />} path="/Kassa" />
        <Route
          element={<PreserveSearchRedirect to={adminPath("Hisobkitob")} />}
          path="/Hisobkitob"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("accauntlar")} />}
          path="/accauntlar"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("Sotuvchilar")} />}
          path="/Sotuvchilar"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("Maxsulotqosh")} />}
          path="/Maxsulotqosh"
        />
        <Route
          element={<PreserveSearchRedirect to={adminPath("MaxsulotTarix")} />}
          path="/MaxsulotTarix"
        />
        <Route element={<PreserveSearchRedirect to={adminPath("Vozvrat")} />} path="/Vozvrat" />
        <Route
          element={<PreserveSearchRedirect to={adminPath("Sozlamalar")} />}
          path="/Sozlamalar"
        />
        <Route element={<PreserveSearchRedirect to={adminPath("foyda")} />} path="/foyda" />

        <Route element={<Navigate replace to="/" />} path="*" />
      </Routes>
      </SkladProvider>
    </Router>
  );
}
